module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item dropdown notification-list custom-notification-list"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle arrow-none waves-light waves-effect",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "false",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.setSeen
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "value": _vm.unSeenReminders.length > 0,
      "manual": true,
      "content": "Vous avez des rappels de rendez-vous en attente.",
      "placement": "bottom"
    }
  }, [_c('span', [_c('i', {
    staticClass: "zmdi zmdi-notifications-none noti-icon"
  }), _vm._v(" "), (_vm.unSeenReminders.length > 0) ? _c('span', {
    staticClass: "noti-icon-badge"
  }) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right dropdown-arrow dropdown-lg",
    attrs: {
      "aria-labelledby": "Preview"
    }
  }, [_c('div', {
    staticClass: "dropdown-item noti-title"
  }, [_c('h5', [_c('small', [(_vm.unSeenReminders.length > 0) ? _c('span', {
    staticClass: "label label-danger pull-xs-right"
  }, [_vm._v(_vm._s(_vm.unSeenReminders.length))]) : _vm._e(), _vm._v("\n          Rappels (rendez-vous)\n        ")])])]), _vm._v(" "), _vm._l((_vm.models.reminders), function(reminder) {
    return _c('a', {
      class: 'dropdown-item notify-item ' + [reminder.seen ? '' : 'not-seen'],
      attrs: {
        "href": '#/customers/' + reminder.customer_id
      }
    }, [_c('div', {
      staticClass: "edit-button",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setNotDisplayed(reminder.id);
          return false;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('p', {
      staticClass: "notify-details"
    }, [_c('strong', {
      style: ({
        'color': reminder.category.color
      })
    }, [_vm._v(_vm._s(reminder.category.name))]), _vm._v(" "), _c('br'), _c('customer', {
      attrs: {
        "item": _vm.models.customers.find(function (customer) { return customer.id === reminder.customer_id; }),
        "present": "name"
      }
    }), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Rendez-vous " + _vm._s(_vm._f("moment")(reminder.date.date, "from", "now")))])], 1)])
  }), _vm._v(" "), (_vm.models.reminders.length === 0) ? _c('a', {
    staticClass: "dropdown-item notify-item"
  }, [_c('p', {
    staticClass: "notify-details"
  }, [_vm._v("Aucun rappel non lu")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item notify-item notify-all",
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "to": "/reminders"
    }
  }, [_vm._v("\n      Voir tous les rappels\n    ")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f5c1076"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Templates/TopBar/TopBarAlert.vue
// module id = 698
// module chunks = 1